/* REWA · Landing Tónico — interacción de la maqueta */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  // Marca un elemento como ya enlazado (el editor de temas puede volver a llamar init)
  const once = (el) => (el.dataset.rlBound ? false : (el.dataset.rlBound = '1'));
  let countdownTimer;

  // Cuenta regresiva: se guarda en el navegador para que no reinicie al recargar
  function initCountdown() {
    const el = $('[data-rl-countdown]');
    if (!el) return;
    clearInterval(countdownTimer);
    const KEY = 'rewa_offer_end';
    const hours = Number(el.dataset.hours) || 2;
    let end = 0;
    try { end = Number(localStorage.getItem(KEY)) || 0; } catch (e) {}
    if (!end || end < Date.now()) {
      end = Date.now() + hours * 3600 * 1000;
      try { localStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    const pad = (n) => String(n).padStart(2, '0');
    const hh = $('[data-hh]', el), mm = $('[data-mm]', el), ss = $('[data-ss]', el);
    const tick = () => {
      const s = Math.floor(Math.max(0, end - Date.now()) / 1000);
      hh.textContent = pad(Math.floor(s / 3600));
      mm.textContent = pad(Math.floor(s / 60) % 60);
      ss.textContent = pad(s % 60);
    };
    tick();
    countdownTimer = setInterval(tick, 1000);
  }

  // Galería. Con data-rl-swap hay un grupo de fotos por opción del selector y se muestra el del producto elegido.
  let gallerySetGroup = null;
  function initGallery() {
    const root = $('[data-rl-gallery]');
    if (!root || !once(root)) return;
    const counter = $('[data-rl-counter]', root);
    const groups = $$('[data-rl-group]', root);
    let scope = groups.find((g) => !g.hidden) || root;
    let thumbsBox = $$('[data-rl-thumbs]', root).find((b) => b.dataset.rlThumbs === scope.dataset.rlGroup) || root;
    let current = 0;
    const slides = () => $$('[data-rl-slide]', scope);
    const thumbs = () => $$('[data-rl-thumb]', thumbsBox);
    const show = (i) => {
      const list = slides();
      current = (i + list.length) % list.length;
      list.forEach((s, n) => s.classList.toggle('is-active', n === current));
      thumbs().forEach((t, n) => t.classList.toggle('is-active', n === current));
      if (counter) counter.textContent = `${current + 1} / ${list.length}`;
    };
    $('[data-rl-prev]', root)?.addEventListener('click', () => show(current - 1));
    $('[data-rl-next]', root)?.addEventListener('click', () => show(current + 1));
    $$('[data-rl-thumb]', root).forEach((t) => t.addEventListener('click', () => show(Number(t.dataset.rlThumb))));

    if (!groups.length) return;
    gallerySetGroup = (idx) => {
      const g = groups.find((x) => Number(x.dataset.rlGroup) === idx);
      if (!g) return;
      scope = g;
      groups.forEach((x) => (x.hidden = x !== g));
      const many = slides().length > 1;
      $$('[data-rl-thumbs]', root).forEach((b) => (b.hidden = !(b.dataset.rlThumbs === g.dataset.rlGroup && many)));
      thumbsBox = $$('[data-rl-thumbs]', root).find((b) => b.dataset.rlThumbs === g.dataset.rlGroup) || root;
      ['[data-rl-prev]', '[data-rl-next]', '[data-rl-counter]'].forEach((s) => { const e = $(s, root); if (e) e.hidden = !many; });
      // La etiqueta (ej. "AHORRAS $8.000") es del producto de la página: solo se ve con sus propias fotos
      const badge = $('[data-rl-badge]', root);
      if (badge) badge.hidden = g.dataset.rlOwn !== '1';
      show(0);
    };
    gallerySetGroup(Number(scope.dataset.rlGroup));
  }

  // Selector de kits: actualiza precio, regalos, barra fija, oferta final y todos los botones de compra
  function initKits() {
    const kits = $$('[data-rl-kit]');
    const select = (btn) => {
      const d = btn.dataset;
      const idx = Number(d.rlKit);
      kits.forEach((k) => k.classList.toggle('is-selected', k === btn));
      $$('[data-rl-price]').forEach((e) => (e.textContent = d.price));
      $$('[data-rl-compare]').forEach((e) => (e.textContent = d.compare));
      $$('[data-rl-save]').forEach((e) => (e.textContent = d.save));
      $$('[data-rl-save-wrap]').forEach((e) => (e.hidden = !d.save));
      $$('[data-rl-title]').forEach((e) => (e.textContent = d.title));
      $$('[data-rl-checkout]').forEach((a) => (a.href = d.url));
      if (gallerySetGroup) gallerySetGroup(idx);
      const gifts = Number(d.gifts) || 1;
      $$('[data-rl-gift]').forEach((g) => g.classList.toggle('is-on', gifts >= Number(g.dataset.rlGift)));
      // La oferta final resalta la tarjeta del mismo producto elegido arriba
      $$('[data-rl-offer]').forEach((o) => o.classList.toggle('is-selected', o.dataset.rlOfferProduct ? o.dataset.rlOfferProduct === d.product : Number(o.dataset.rlOffer) === idx));
    };
    kits.forEach((k) => once(k) && k.addEventListener('click', () => select(k)));
    const initial = kits.find((k) => k.classList.contains('is-selected')) || kits[0];
    if (initial) select(initial);
  }

  function initDelivery() {
    const hero = $('[data-rl-hero]');
    const el = $('[data-rl-delivery]');
    if (!hero || !el) return;
    const min = Number(hero.dataset.rlDeliveryMin) || 2;
    const max = Number(hero.dataset.rlDeliveryMax) || 4;
    const d = (n) => {
      const x = new Date();
      x.setDate(x.getDate() + n);
      return x.toLocaleDateString('es-CO', { weekday: 'short', day: 'numeric', month: 'short' });
    };
    el.textContent = `${d(min)} y el ${d(max)}`;
  }

  function initAccordions() {
    $$('[data-rl-acc]').forEach((item) => {
      const btn = item.querySelector('.rl-acc__btn');
      if (!once(btn)) return;
      btn.addEventListener('click', () => {
        const open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  // Botón flotante de la app WhatsApp (Eazeapps): lo sube por encima de la barra fija "Pedir ahora".
  // La app lo dibuja dentro de un shadow DOM, así que el estilo se inyecta ahí.
  function liftWhatsApp() {
    const sticky = $('.rl-sticky');
    if (!sticky) return;
    const apply = () => {
      const host = $('gty-whatsapp-chat-button');
      if (!host || !host.shadowRoot) return false;
      let style = host.shadowRoot.querySelector('#rl-lift');
      if (!style) {
        style = document.createElement('style');
        style.id = 'rl-lift';
        host.shadowRoot.appendChild(style);
      }
      style.textContent = `.gty-wacb-wrapper { bottom: ${sticky.offsetHeight + 12}px !important; }`;
      return true;
    };
    if (apply()) return;
    const observer = new MutationObserver(() => {
      if (apply()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 30000);
    window.addEventListener('resize', apply);
  }

  const init = () => {
    liftWhatsApp();
    initCountdown();
    initGallery();
    initKits();
    initDelivery();
    initAccordions();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Editor de temas: volver a enlazar cuando se recarga una sección
  document.addEventListener('shopify:section:load', init);
})();
